import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
} from '@mui/material'
import { useState } from 'react'
import PrimeTable from '../../../components/PrimeTable'
import CurrencyField from '../../../components/CurrencyField/CurrencyField'
import { metodoPrograma } from '../../../components/api'
import { setError, setSuccess } from '../../../components/alerts'

const FormularioEstorno = ({ inicial, salvar, close }) => {
  const [estorno, setEstorno] = useState(inicial)
  return (
    <Grid container spacing={1} sx={{ p: 1, minWidth: 360 }}>
      <Grid item xs={12}>
        <TextField
          fullWidth
          size="small"
          label="Descrição"
          value={estorno.dsEstorno || ''}
          onChange={(e) =>
            setEstorno({ ...estorno, dsEstorno: e.target.value })
          }
        />
      </Grid>
      <Grid item xs={12}>
        <CurrencyField
          size="small"
          label="Valor"
          value={estorno.vlEstorno || 0}
          onChange={(vlEstorno) => setEstorno({ ...estorno, vlEstorno })}
        />
      </Grid>
      <Grid item xs={6}>
        <Button fullWidth onClick={close}>
          Cancelar
        </Button>
      </Grid>
      <Grid item xs={6}>
        <Button
          fullWidth
          variant="contained"
          onClick={() => salvar(estorno, close)}
        >
          Salvar
        </Button>
      </Grid>
    </Grid>
  )
}

const ModalEstornos = ({ close, data }) => {
  const { codigo, idPedidoVenda, idAtendimento, onAtualizar } = data
  const [refresh, setRefresh] = useState(0)
  const salvar = async (estorno, fechar) => {
    if (!estorno.dsEstorno?.trim() || Number(estorno.vlEstorno) <= 0)
      return setError('Informe a descrição e um valor maior que zero.')
    const resposta = await metodoPrograma(
      'salvaEstorno',
      { ...estorno, idPedidoVenda, idAtendimento },
      codigo,
    )
    if (!resposta.status)
      return setError(resposta.dsErro || 'Não foi possível salvar o estorno')
    setSuccess(estorno.idEstorno ? 'Estorno alterado' : 'Estorno registrado')
    fechar()
    setRefresh((atual) => atual + 1)
    onAtualizar?.()
    window.dispatchEvent(new Event('estornos-atualizados'))
  }
  const excluir = async (estorno) => {
    const resposta = await metodoPrograma(
      'excluiEstorno',
      {
        idEstorno: Array.isArray(estorno) ? estorno[0] : estorno.idEstorno,
        idPedidoVenda,
        idAtendimento,
      },
      codigo,
    )
    if (!resposta.status)
      return setError(resposta.dsErro || 'Não foi possível excluir o estorno')
    setSuccess('Estorno excluído')
    setRefresh((atual) => atual + 1)
    onAtualizar?.()
    window.dispatchEvent(new Event('estornos-atualizados'))
  }
  return (
    <Dialog maxWidth="md" fullWidth open onClose={() => close()}>
      <DialogTitle>Estornos de pagamento</DialogTitle>
      <DialogContent dividers>
        <PrimeTable
          codigo={codigo}
          action="listaEstornos"
          parametros={{ idPedidoVenda, idAtendimento }}
          refresh={refresh}
          head={['Data', 'Descrição', 'Valor']}
          collumnsDateHour={[0]}
          collumnsCurrency={[2]}
          line={(item) =>
            Array.isArray(item)
              ? [item[1], item[2], item[3]]
              : [item.dtExtorno, item.dsEstorno, item.vlEstorno]
          }
          addButton
          editButton
          fastAddComponent={({ close: fechar }) => (
            <FormularioEstorno
              inicial={{ dsEstorno: '', vlEstorno: 0 }}
              salvar={salvar}
              close={fechar}
            />
          )}
          fastEditComponent={({ linha, close: fechar }) => (
            <FormularioEstorno
              inicial={{
                idEstorno: Array.isArray(linha) ? linha[0] : linha.idEstorno,
                dsEstorno: Array.isArray(linha) ? linha[2] : linha.dsEstorno,
                vlEstorno: Array.isArray(linha) ? linha[3] : linha.vlEstorno,
              }}
              salvar={salvar}
              close={fechar}
            />
          )}
          onDelete={{ index: 10, action: excluir }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => close()}>Fechar</Button>
      </DialogActions>
    </Dialog>
  )
}

export default ModalEstornos
